import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deadline",
  "use": "deadline-usage",
  "viewBox": "-40 0 512 512",
  "content": "<symbol viewBox=\"-40 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"deadline\"><path d=\"M382.867 157.379l20.074-20.074c7.801-7.801 7.801-20.45 0-28.246-7.8-7.801-20.445-7.801-28.246 0l-20.074 20.074c-33.68-28.063-74.605-45.016-118.262-48.985V39.95h19.309c11.031 0 19.973-8.945 19.973-19.976S266.699 0 255.668 0h-78.566c-11.032 0-19.973 8.941-19.973 19.973s8.941 19.976 19.973 19.976h19.308v40.2C87.13 90.085 0 181.89 0 295.612 0 415.207 96.777 512 216.387 512c119.59 0 216.383-96.777 216.383-216.387 0-51.086-17.594-99.465-49.903-138.234zM216.383 472.05c-97.285 0-176.438-79.149-176.438-176.438 0-97.285 79.153-176.433 176.438-176.433 97.289 0 176.437 79.148 176.437 176.433 0 97.29-79.148 176.438-176.437 176.438zm92.566-269c7.801 7.8 7.801 20.449 0 28.246l-78.441 78.441c-7.801 7.801-20.45 7.801-28.246 0-7.801-7.8-7.801-20.449 0-28.246l78.437-78.441c7.801-7.801 20.45-7.801 28.25 0zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/deadline.svg
// module id = BFwi
// module chunks = 1